namespace SorAraBul.Definitions {
    export interface CitiesRow {
        Id?: number;
        Name?: string;
        CountryId?: number;
        StateId?: number;
        CityCode?: number;
        CountriesName?: string;
    }

    export namespace CitiesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Definitions.Cities';
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = '*';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            CountryId = "CountryId",
            StateId = "StateId",
            CityCode = "CityCode",
            CountriesName = "CountriesName"
        }
    }
}
